
const navItems = ['home', 'about', 'work', 'skills', 'testimonials', 'contact'];
const workItems = ['PHP', 'Web App', 'React JS', 'All'];

export default {
    navItems,
    workItems
};